export const HOME_PAGE = {
  startTrainingButton: "home-start-training-button",
  introVideoPlaceholder: "home-intro-video-placeholder",
};

export const TRAINING = {
  moduleCard: (id) => `training-module-card-${id}`,
  moduleLockedBadge: (id) => `training-module-locked-badge-${id}`,
  playButton: (id) => `training-module-play-button-${id}`,
  markCompleteButton: (id) => `training-module-complete-button-${id}`,
  completedBadge: (id) => `training-module-completed-badge-${id}`,
  continueToQuizButton: "training-continue-to-quiz-button",
  progressBar: "training-overall-progress-bar",
};

export const PRODUCT_GUIDE = {
  slide: (id) => `product-guide-slide-${id}`,
  prevButton: "product-guide-prev-button",
  nextButton: "product-guide-next-button",
  dot: (i) => `product-guide-dot-${i}`,
  youtubeCard: (id) => `product-guide-youtube-card-${id}`,
  youtubeIframe: (id) => `product-guide-youtube-iframe-${id}`,
};

export const QUIZ = {
  startButton: "quiz-start-button",
  lockedMessage: "quiz-locked-message",
  questionCard: "quiz-question-card",
  optionRadio: (qid, opt) => `quiz-option-${qid}-${opt}`,
  nextQuestionButton: "quiz-next-question-button",
  submitButton: "quiz-submit-button",
  timer: "quiz-timer",
  progressIndicator: "quiz-progress-indicator",
  resultScore: "quiz-result-score",
  resultReviewItem: (qid) => `quiz-result-review-item-${qid}`,
  retryButton: "quiz-retry-button",
  restartTrainingButton: "quiz-restart-training-button",
  congratsModal: "quiz-congrats-modal",
  viewCertificateButton: "quiz-view-certificate-button",
};

export const CERTIFICATE = {
  container: "certificate-container",
  downloadButton: "certificate-download-button",
  backButton: "certificate-back-button",
};

export const ADMIN = {
  emailInput: "admin-login-email-input",
  passwordInput: "admin-login-password-input",
  loginButton: "admin-login-submit-button",
  errorMessage: "admin-login-error-message",
  logoutButton: "admin-logout-button",
  statCard: (key) => `admin-stat-card-${key}`,
  participantRow: (id) => `admin-participant-row-${id}`,
  viewAttemptsButton: (id) => `admin-view-attempts-button-${id}`,
  backButton: "admin-back-button",
  attemptCard: (id) => `admin-attempt-card-${id}`,
};
